import { render, staticRenderFns } from "./HotClassComponent.vue?vue&type=template&id=00781dca&"
import script from "./HotClassComponent.vue?vue&type=script&lang=js&"
export * from "./HotClassComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports